export const blacklistedNames: string[] = [
    "brightlysoftware", "metadata",
    "kind", "Namespace", "apiVersion",
    "metadata", "labels", "project-access",
    "kafka-client-credentials", "kafka-cluster",
    "kafka-user", "service-mesh-control-plane", "vault-role",
    "dbaas-cluster", "dbaas-schema", "dbaas-access", "permission-system",
    "pull-secret", "applications", "application", "write", "ecr", "mTLS", "dev",
    "demo", "training"]

export const blacklistedSuffixes: string[] = [
    "-dev", "-staging", "-production", "-training", "-demo", "-uat", "-release", "-feature"
];
